import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mock-exam-page" }
const _hoisted_2 = { class: "mock-exam-page__content" }
const _hoisted_3 = { class: "mock-exam-page__section-header" }
const _hoisted_4 = { class: "mock-exam-page__section-title" }
const _hoisted_5 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-4 g-3 m-0" }
const _hoisted_6 = { class: "mock-exam-page__test-card" }
const _hoisted_7 = { class: "mock-exam-page__test-label" }
const _hoisted_8 = {
  key: 0,
  class: "bi bi-check2 mock-exam-page__status-check",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  key: 1,
  class: "bi bi-lock-fill",
  "aria-hidden": "true"
}
const _hoisted_10 = {
  key: 2,
  class: "bi bi-hourglass-split",
  "aria-hidden": "true"
}
const _hoisted_11 = {
  class: "mock-exam-page__pagination-wrap",
  "aria-label": "صفحه‌بندی کتاب‌ها"
}
const _hoisted_12 = { class: "mock-exam-page__pagination" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["aria-current", "onClick"]
const _hoisted_15 = ["disabled"]

import { ref, computed, onMounted } from "vue";
import { getBooks, getBookTests } from "@/api/books";
import { handleError } from "@/services/errorHandler";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import ErrorMessage from "@/components/common/ErrorMessage.vue";
import EmptyState from "@/components/common/EmptyState.vue";

const BOOKS_PER_PAGE = 5;


export default /*@__PURE__*/_defineComponent({
  __name: 'MockExamPage',
  setup(__props) {

const STATUS_LABELS = {
  completed: "تکمیل‌شده",
  locked: "قفل",
  in_progress: "در حال انجام",
  not_started: "شروع نشده",
};

const currentPage = ref(1);
const loading = ref(true);
const errorMessage = ref("");
const sections = ref([]);

const codeNumber = (code) => Number(String(code).replace(/\D/g, "")) || 0;

function statusLabel(status) {
  return STATUS_LABELS[status] ?? STATUS_LABELS.not_started;
}

async function loadBooks() {
  loading.value = true;
  errorMessage.value = "";
  try {
    const { items } = await getBooks({ page: 1, size: 100 });

    const sorted = [...items].sort(
      (a, b) => codeNumber(b.code) - codeNumber(a.code)
    );

    const withTests = await Promise.all(
      sorted.map(async (book) => {
        let tests = [];
        try {
          tests = await getBookTests(book.id);
        } catch {
          tests = [];
        }
        return {
          title: book.code,
          tests: tests
            .sort((a, b) => a.number - b.number)
            .map((t) => ({
              number: t.number,
              label: `${book.code}Test${t.number}`,
              status: t.status ?? "completed",
            })),
        };
      })
    );

    sections.value = withTests;
    currentPage.value = 1;
  } catch (e) {
    errorMessage.value = handleError(e, "MockExamPage.loadBooks");
  } finally {
    loading.value = false;
  }
}

const totalPages = computed(() =>
  Math.max(1, Math.ceil(sections.value.length / BOOKS_PER_PAGE))
);

const currentSections = computed(() => {
  const start = (currentPage.value - 1) * BOOKS_PER_PAGE;
  return sections.value.slice(start, start + BOOKS_PER_PAGE);
});

function changePage(page) {
  if (page < 1 || page > totalPages.value) return;
  currentPage.value = page;
}

onMounted(loadBooks);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createBlock(LoadingSpinner, {
            key: 0,
            message: "در حال بارگذاری آزمون‌ها..."
          }))
        : (errorMessage.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 1,
              title: "بارگذاری آزمون‌ها انجام نشد",
              message: errorMessage.value,
              onRetry: loadBooks
            }, null, 8, ["message"]))
          : (!currentSections.value.length)
            ? (_openBlock(), _createBlock(EmptyState, {
                key: 2,
                icon: "bi-journal-x",
                title: "آزمونی موجود نیست",
                message: "هنوز کتاب کمبریجی برای نمایش وجود ندارد."
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSections.value, (section, sectionIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: section.title,
                    class: "mock-exam-page__section",
                    style: _normalizeStyle({ animationDelay: `${sectionIndex * 60}ms` })
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mock-exam-page__section-mark" }, null, -1)),
                      _createElementVNode("h5", _hoisted_4, _toDisplayString(section.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.tests, (test) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col",
                          key: test.label
                        }, [
                          _createVNode(_component_router_link, {
                            to: {
                  name: 'mockExamPageDtail',
                  params: {
                    level: section.title,
                    testId: test.number,
                  },
                },
                            class: "mock-exam-page__test-link"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(test.label), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["mock-exam-page__status-badge", `mock-exam-page__status-badge--${test.status}`])
                                }, [
                                  (test.status === 'completed')
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                                    : (test.status === 'locked')
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                                      : (test.status === 'in_progress')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                                        : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(statusLabel(test.status)), 1)
                                ], 2)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ])
                  ], 4))
                }), 128)),
                _createElementVNode("nav", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "mock-exam-page__page-btn mock-exam-page__page-btn--nav",
                      disabled: currentPage.value === 1,
                      "aria-label": "صفحه قبل",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (changePage(currentPage.value - 1)))
                    }, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", {
                        class: "bi bi-chevron-right",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))], 8, _hoisted_13),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: page,
                        type: "button",
                        class: _normalizeClass(["mock-exam-page__page-btn", { 'mock-exam-page__page-btn--active': currentPage.value === page }]),
                        "aria-current": currentPage.value === page ? 'page' : undefined,
                        onClick: ($event: any) => (changePage(page))
                      }, _toDisplayString(page), 11, _hoisted_14))
                    }), 128)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "mock-exam-page__page-btn mock-exam-page__page-btn--nav",
                      disabled: currentPage.value === totalPages.value,
                      "aria-label": "صفحه بعد",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (changePage(currentPage.value + 1)))
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", {
                        class: "bi bi-chevron-left",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))], 8, _hoisted_15)
                  ])
                ])
              ], 64))
    ])
  ]))
}
}

})